import React, { useEffect, useState } from 'react';
import '../reservations/reservationForm.css';

export default function ReservationSettings({ client, orgId }) {
    const [settings, setSettings] = useState(null);
    const [error, setError] = useState('');
    const [notice, setNotice] = useState('');
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        let active = true;
        setSettings(null); setError(''); setNotice('');
        if (!orgId) return undefined;
        client.from('org_reservation_settings').select('airports,charter_minimum_hours,airport_dropoff_lead_minutes,conversation_countdown_seconds').eq('org_id', orgId).single()
            .then(({ data, error: failure }) => { if (active) { if (failure) setError(failure.message); else setSettings(data); } })
            .catch((failure) => { if (active) setError(failure.message); });
        return () => { active = false; };
    }, [client, orgId]);
    async function save(event) {
        event.preventDefault(); setBusy(true); setError(''); setNotice('');
        try {
            const { error: failure } = await client.from('org_reservation_settings').update({
                airports: settings.airports, charter_minimum_hours: Number(settings.charter_minimum_hours),
                airport_dropoff_lead_minutes: Number(settings.airport_dropoff_lead_minutes ?? 150),
                conversation_countdown_seconds:Number(settings.conversation_countdown_seconds??30),

            }).eq('org_id', orgId).select('org_id').single();
            if (failure) throw failure;
            setNotice('Reservation settings saved.');
        } catch (failure) { setError(failure.message || 'Reservation settings could not be saved.'); }
        finally { setBusy(false); }
    }
    return <section className="rounded-xl border p-5">
        <h2 className="text-lg font-semibold">Reservation rules</h2>
        <p>Company admins can change airports, minimum charter hours and airport drop-off lead time. Price is still confirmed by staff.</p>
        {error && <p role="alert">{error}</p>}{notice && <p role="status">{notice}</p>}
        {settings && <form className="reservation-form" onSubmit={save}>
            <fieldset disabled={busy}>
                <label>Conversation reservation countdown (seconds)<input type="number" min={5} max={600} required value={settings.conversation_countdown_seconds??30} onChange={event=>setSettings({...settings,conversation_countdown_seconds:event.target.value})} /></label>

                <label>Airport drop-off lead time (minutes)<input type="number" min={0} step={1} required value={settings.airport_dropoff_lead_minutes ?? 150}
                    onChange={(e) => setSettings({ ...settings, airport_dropoff_lead_minutes: e.target.value })} /></label>
                <p>Default: 150 minutes (2h 30m). Suggestions do not include routing or traffic.</p>
                <label>Minimum charter hours<input type="number" min={1} max={72} step={0.5} required value={settings.charter_minimum_hours}
                    onChange={(e) => setSettings({ ...settings, charter_minimum_hours: e.target.value })} /></label>
                {settings.airports.map((airport, index) => <div className="rf-grid" key={index}>
                    {['code', 'name', 'address'].map((key) => <label key={key}>Airport {index + 1} {key}
                        <input required value={airport[key]} maxLength={key === 'code' ? 3 : key === 'name' ? 120 : 500}
                            onChange={(e) => setSettings({ ...settings, airports: settings.airports.map((a, i) => i === index ? { ...a, [key]: key === 'code' ? e.target.value.toUpperCase() : e.target.value } : a) })} />
                    </label>)}
                    <button type="button" disabled={settings.airports.length === 1}
                        onClick={() => setSettings({ ...settings, airports: settings.airports.filter((_, i) => i !== index) })}>Remove airport {index + 1}</button>
                </div>)}
                <button type="button" disabled={settings.airports.length >= 50} onClick={() => setSettings({ ...settings, airports: [...settings.airports, { code: '', name: '', address: '' }] })}>Add airport</button>
                <button type="submit">{busy ? 'Saving...' : 'Save reservation rules'}</button>
            </fieldset>
        </form>}
    </section>;
}
